import React, { useEffect } from "react";
import Router from "./routes/routing";
import { WhitelabelProvider } from "./context/whitelabel.context";
import { GamesProvider } from "./context/games.context";
import { AuthProvider, useAuth } from "./context/auth.context";
import { ControlesProvider } from "./context/controles.context";
import { ClienteProvider } from "./context/cliente.context";


function App() {
  return (
    <>
      <WhitelabelProvider>
        <ClienteProvider>
          <ControlesProvider>
            <AuthProvider>
              <GamesProvider>
                <Router/>
              </GamesProvider>
            </AuthProvider>
          </ControlesProvider>
        </ClienteProvider>
      </WhitelabelProvider>
    </>
  );
}

export default App;
